import { StoreNestedFilterExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../models/fact-mapping.interface';
import { FactExtractor } from '../fact-extractor';

/**
 * @description the config for the asset class decomposition facts. Returns a sum of acAssetClasses type equal to cash.
 * This fact is consumed by the insight engine to determine if the insight should be displayed or not.
 */
export const ASSET_CLASS_DECOMPOSITION_FACTS: { [factName: string]: FactMappingInterface } = {
	assetClassDecomposition: {
		extractor: new FactExtractor([
			new StoreNestedFilterExtractor(
				['details'],
				'details.portfolioBreakdowns',
				[
					{ propertyToCompare: 'name', comparedValue: 'acAssetClass', desiredValueExpression: 'sectors' }
				],
				0
			)
		], sectors => {
			const assetsForCash = sectors.filter(asset => asset.name.toLowerCase() === 'cash');
			let sum = 0;
			assetsForCash.forEach(asset => {
				sum += asset.contribution;
			});
			return sum * 100;
		})
	}
};
